/* eslint-disable class-methods-use-this */
import {
  get,
  _delete,
} from '@/lin/plugins/axios'

const _baseUri = 'plugin/xy/tag/'

class Article {
  async getTags() {
    const res = await get(`${_baseUri}all`)
    return res
  }

  async deleteByName(name) {
    const res = await _delete(`${_baseUri}${name}`)
    return res
  }
}

export default new Article()
